<template>
  <div id="app" class="container-fluid">
    <nav class="navbar navbar-expand-lg navbar-light justify-content-end custom_nav">
      <router-link to="/" class="navbar-brand">Keep LoLing S2</router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-center" id="navbarNavDropdown">
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link to="/" class="nav-link" id="nav-home">Home</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/About" class="nav-link" id="nav-about">About</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/Videos" class="nav-link" id="nav-videos">Videos</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/Art" class="nav-link" id="nav-art">Art</router-link>
          </li>
          <li class="nav-item">
            <router-link to="/Blog" class="nav-link" id="nav-blog">Blog</router-link>
          </li>
        </ul>
      </div>
    </nav>
    <router-view/>
    <keep-alive><Updates v-show="showHome"/></keep-alive>
    <router-link v-show="showHome" to="/Blog#top" class="btn readMore" id="goto-blog">Read More</router-link>
    <!-- Begin Mailchimp Signup Form -->
    <link href="//cdn-images.mailchimp.com/embedcode/horizontal-slim-10_7.css" rel="stylesheet" type="text/css">
    <div id="mc_embed_signup">
    <form action="https://github.us10.list-manage.com/subscribe/post?u=a773e4f44343f0f95816fda6d&amp;id=017ce7acd8" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
      <div id="mc_embed_signup_scroll">
      <h2 class="latest" for="mce-EMAIL">Subscribe</h2>
      <p>Sign up for the newsletter to stay tuned with the newest content from Keep LoLing S2, including the newest blog posts, YouTube videos and doodles!</p>
      <input type="email" value="" name="EMAIL" class="email" id="mce-EMAIL" placeholder="email address" required>
        <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
        <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_a773e4f44343f0f95816fda6d_017ce7acd8" tabindex="-1" value=""></div>
        <div class="clear"><input type="submit" value="Subscribe" name="subscribe" id="mc-embedded-subscribe" class="button readMore"></div>
        </div>
    </form>
    </div>

    <!--End mc_embed_signup-->
    <SocialMedia/>
  </div>
</template>

<script>
import SocialMedia from '@/components/socialmedia'
import Updates from '@/components/Updates'

export default {
  name: 'App',
  components: {
    Updates,
    SocialMedia
  },
  data () {
    return {
      component: Updates
    }
  },
  computed: {
    showHome () {
      if (this.$route.path === '/') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue